export default __webpack_public_path__ + "static/media/gabriel-vinderola.69bac18a.png";